import { jsx as _jsx } from "react/jsx-runtime";
import * as Moment from "moment";
import * as React from "react";
import { slugify } from "../../../Shared/utils/string";
import { getCurrentFilterQuery } from "./filters";
import { Link } from "./library/link";
import { TeaserContent } from "./teaser";
export const ActivitySummary = (p)=>p.title == "loading" ? null : /*#__PURE__*/ _jsx("li", {
        className: "teaser teaser--default teaser--image col-xs-12 col-sm-6 col-md-4",
        children: /*#__PURE__*/ _jsx(Link, {
            url: `${p.route}${getCurrentFilterQuery(false)}`,
            className: "teaser__link",
            handle: ()=>p.onClick && p.onClick(),
            "aria-labelledby": `a11y-teaser-title-${slugify(p.title)}`,
            children: /*#__PURE__*/ _jsx(TeaserContent, {
                headingLevel: p.headingLevel,
                title: p.title,
                isTip: p.isTip,
                imageUrl: p.styleUrls["400x280"],
                imageUrlFallback: p.styleUrls["4x3"],
                imageUrlLarge: p.styleUrls["800x560"],
                imageAlt: p.imageAlt,
                label: p.date == "multiple" ? null : /*#__PURE__*/ _jsx("time", {
                    dateTime: Moment(p.date.getTime() - p.date.getTimezoneOffset() * 60000).format('L'),
                    children: Moment(new Date(p.date.getTime() - p.date.getTimezoneOffset() * 60000)).format("L")
                }),
                intro: p.subtitle,
                locationFooter: p.location == "multiple" ? "Meerdere locaties" : p.location
            })
        }, p.route)
    });
{}